export default "__VITE_ASSET__BstoRsx___"